<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-card z-card--only-desktop spacer-bottom-m">
            <z-icon :icon="['far', 'check-circle']" size="extra-large" color="success" class="success-icon" />

            <div class="z-title z-title--small spacer-bottom-l">
              O seu {{ periodName }} foi pago com sucesso
            </div>

            <p class="z-text">
              Você pagou o seu {{ periodName }} <b>usando um cartão de crédito</b>. Você pode baixar
              o comprovante de pagamento.
            </p>
          </div>

          <payment-receipt :bill="bill" :course-name="currentBilling.course_name" :student-name="student.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.success-icon {
  margin-bottom: var(--space-medium);
}

.z-card--only-desktop {
  @media (max-width: $screen-sm-max) {
    background-color: unset;
    box-shadow: unset;
    padding: unset;
    transition: unset;
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import DashboardService from 'services/DashboardService';
import PaymentReceipt from 'components/payment-receipt';
import Breadcrumb from 'components/breadcrumb';

export default {
  components: {
    Breadcrumb,
    PaymentReceipt,
  },
  data() {
    return {
      bill: {},
    };
  },
  computed: {
    ...mapState([
      'student',
      'currentBilling',
      'currentContract',
    ]),
    periodName() {
      return this.currentContract.period_name;
    },
  },
  methods: {
    ...mapActions([
      'loadCurrentBill',
      'loadOverdueBills',
      'loadCurrentContract',
    ]),
    loadReceiptData() {
      this.$pageLoader.show();

      new Promise((resolve, reject) => this.pollingForBillPaid(resolve, reject))
        .then(() => {
          Promise.all([
            this.loadCurrentBill(),
            this.loadOverdueBills(),
            this.loadCurrentContract(),
          ]);
        }, (error) => {
          throw error;
        })
        .catch((error) => {
          this.$rollbar.error(error);
          this.$router.push({ name: 'panel' });
        })
        .finally(() => this.$pageLoader.hide());
    },
    pollingForBillPaid(resolve, reject) {
      setTimeout(() => {
        DashboardService.getDischargedBills(this.currentContract.id)
          .then((bills) => {
            [this.bill] = bills;

            if (!this.bill || (this.bill.status !== 'paid')) {
              this.pollingForBillPaid(resolve);
            } else {
              resolve();
            }
          })
          .catch((error) => reject(error));
      }, 1000);
    },
  },
  created() {
    this.loadReceiptData();
  },
};
</script>
